module.exports = __webpack_public_path__ + "img/flag-mexico.633e090c.png";